import React from "react";
import { useNavigate } from "react-router-dom";

const HomeProductCard = ({ product }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/product/${product?.id}`)}
      className="cursor-pointer flex flex-col bg-organic-beige hover:-translate-y-2 transition-transform duration-300 border border-transparent hover:border-organic-green overflow-hidden rounded-lg"
    >
      {/* Image container - full width, fixed aspect ratio */}
      <div className="w-full aspect-square overflow-hidden">
        <img
          className="object-cover w-full h-full"
          src={product?.imageUrl}
          alt={product?.title}
        />
      </div>

      {/* Content section */}
      <div className="p-4">
        <h3 className="text-lg font-medium text-organic-charcoal line-clamp-2">
          {product?.title}
        </h3>
        <p className="mt-1 text-sm text-gray-500">{product?.brand}</p>
        <div className="mt-2 flex items-center gap-2 flex-wrap">
          <span className="text-lg font-bold text-organic-green">${typeof product?.discountedPrice === 'number' ? product.discountedPrice.toFixed(2) : product?.discountedPrice}</span>
          {product?.discountPersent > 0 && (
            <>
              <span className="text-sm text-gray-400 line-through">${typeof product?.price === 'number' ? product.price.toFixed(2) : product?.price}</span>
              <span className="text-sm text-red-500">({product?.discountPersent}% off)</span>
            </>
          )}
        </div>
        <button className="mt-4 w-full bg-organic-green text-white py-2 px-4 rounded text-xs font-bold uppercase tracking-wider hover:bg-opacity-90 transition-colors">
          View Options
        </button>
      </div>
    </div>
  );
};

export default HomeProductCard;
